<template>
  <b-row>
    <b-col cols="12">
      <listing-search-form
        @change="onSearchResult"
        @click="onSearchClick"
        :pagination="pagination"
        :fields="listingSearchFields"
      ></listing-search-form>
    </b-col>
    <b-col cols="12" xl="7">
      <transition name="slide">
        <b-card>
          <div slot="header">
            <strong>Listings</strong>
          </div>
          <pagination-table
            :items="listings"
            :fields="[
              {key: 'name'},
              {key: 'status'},
              {key: 'type'},
              {key: 'actions'},
            ]"
            :pagination="pagination"
            :is-loading="isLoading"
            @change="onPaginationChange"
            item-url="newsletter/listing/{id}"
          ></pagination-table>
        </b-card>
      </transition>
    </b-col>
    <b-col cols="12" xl="5">
      <flash-message transitionIn="animated swing"></flash-message>
      <b-card>
        <div slot="header">
          <strong>Listing</strong>
        </div>
        <listing-form :add-option="true"></listing-form>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>

  import {RepositoryFactory} from "@/services/repositories/RepositoryFactory";
  import {Listing} from "@/models/NewsLetter/Listing";
  import {PaginationMeta} from "@/models/PaginationMeta";
  import ListingForm from "../../components/newsletter/Listing/ListingForm";
  import PaginationTable from "../../components/base/PaginationTable";
  import ListingSearchForm from "../../components/newsletter/Listing/ListingSearchForm";
  import {SearchField} from "@/services/SearchField";
  import {parseEnum} from "@/shared/utils";

  const ListingRepo = RepositoryFactory.get('newsletterListing')

  export default {
    name: 'Listings',
    components: {
      ListingSearchForm,
      PaginationTable,
      ListingForm,
    },
    data: () => {
      return {
          listings: new Array(new Listing()),
          pagination: new PaginationMeta(),
          isLoading: true,
          searchParams: {},
          listingSearchFields: [
            new SearchField()
              .setLabel('Name')
              .setKey('name')
              .setDescription('Filter name.')
              .setType(SearchField.FIELD_TYPES.FIELD_TEXT)
            ,
            new SearchField()
              .setLabel('Type')
              .setDescription('Filter type.')
              .setKey('type')
              .setType(SearchField.FIELD_TYPES.FIELD_SELECT)
              .setValues(parseEnum(Listing.TYPES))
            ,
            new SearchField()
              .setLabel('Status')
              .setDescription('Filter Status.')
              .setKey('status')
              .setType(SearchField.FIELD_TYPES.FIELD_SELECT)
              .setValues(parseEnum(Listing.STATUS))
            ,
            new SearchField()
              .setLabel('ID')
              .setDescription('Filter ID.')
              .setKey('id')
              .setType(SearchField.FIELD_TYPES.FIELD_TEXT)
              .setIsAdvanced(true)
            ,
            new SearchField()
              .setLabel('Email')
              .setDescription('Filter Person Email.')
              .setKey('personEmail')
              .setType(SearchField.FIELD_TYPES.FIELD_TEXT)
              .setIsAdvanced(true)
            ,
          ],
      }
    },
    mounted () {
      ListingRepo
              .get()
              .then(
                  response => (
                      this.listings = response.data.data,
                      this.pagination = response.data.meta,
                      this.isLoading = false
                  )
              )
    },
    methods: {
        onSearchResult(response) {
            this.listings = response.data,
            this.pagination = response.meta,
            this.isLoading   = false
        },
        onSearchClick(params) {
            this.isLoading = true
            this.searchParams = params
        },
        onPaginationChange() {
          this.searchParams.page = this.pagination.page;
          this.searchParams.limit = this.pagination.limit;

          ListingRepo
            .searchListing(this.searchParams)
            .then(
              response => (
                  this.listings = response.data.data,
                  this.pagination = response.data.meta,
                  this.isLoading = false
              )
            )
        },
    }
  }
</script>
